/**
 * Coups de pouce, Attendus 1225 « résoudre des équations du type ax = c et
 * x + b = c » et 1226 « du type ax + b = c » (3e, Calcul littéral, l. 794 ;
 * un fichier gen_1225 à deux jeux de clés). Seconde passe 3e (2026-09-13).
 * Une page STATIQUE par attendu.
 *
 * L'image que l'élève a déjà : « je défais l'opération » (4e, l. 619,
 * « par des méthodes arithmétiques s'appuyant sur les opérations
 * inverses » ; fiches 1107 « Ce qui manque »). Le neuf de 3e est le
 * signe (x + 8 = 3 donne un négatif) et l'enchaînement des deux étapes.
 *   1225 « Je défais l'opération » : deux lignes, une par forme.
 *     x + 8 = 3 : « + 8 » se défait en « − 8 » des deux côtés, x = 3 − 8 puis
 *     x = −5 sur deux lignes alignées (demande prof 2026-09-18)
 *     (le signe compte) ; 3x = 12 : « × 3 » se défait en « ÷ 3 », x = 4.
 *   1226 « Deux étapes » : 3x + 2 = 14, d'abord − 2 (3x = 12), puis ÷ 3
 *     (x = 4) ; le nombre seul d'abord, la division ensuite. Vérification :
 *     3 × 4 + 2 = 14.
 *
 * SACRIFIÉS (gen_1225, gen1225.self.test.js) : (8 ; 3) dans x + b = c,
 * (3 ; 12) dans ax = c, (3x + 2 ; 14) sous toutes ses formes.
 */
import { svg } from './1054';

const ORANGE = '#EA580C';
const BLEU = '#2563EB';
const ENCRE = '#1E293B';
const GRIS = '#64748B';

const ligne = (y, contenu, taille = 12, couleur = ENCRE, x = 200, ancre = 'middle') => `<text x="${x}" y="${y}" font-size="${taille}" text-anchor="${ancre}" fill="${couleur}">${contenu}</text>`;
/** Une étiquette « − 8 » ou « ÷ 3 » en orange sous un membre, avec sa flèche. */
const defaire = (x, y, texte) => `<line x1="${x}" y1="${y - 14}" x2="${x}" y2="${y + 2}" stroke="${ORANGE}" stroke-width="1.2"/>
  <text x="${x}" y="${y + 14}" font-size="12" font-weight="bold" text-anchor="middle" fill="${ORANGE}">${texte}</text>`;

// ─── 1225 : x + 8 = 3 et 3x = 12 ───────────────────────────────────────────

const SVG_UNE_ETAPE = svg(
    'x plus 8 égale 3. Je défais le plus 8 : moins 8 des deux côtés. x égale 3 moins 8, donc x égale moins 5. Le signe compte. 3x égale 12. Je défais le fois 3 : divisé par 3 des deux côtés. x égale 12 divisé par 3, donc x égale 4.',
    `<!-- 1. x + 8 = 3 -->
  ${ligne(40, `<tspan font-weight="bold">x</tspan> <tspan fill="${BLEU}" font-weight="bold">+ 8</tspan> = 3`, 18, ENCRE, 110)}
  ${defaire(96, 58, '− 8')}
  ${defaire(146, 58, '− 8')}
  ${ligne(34, 'x = 3 − 8', 16, ENCRE, 250, 'start')}
  ${ligne(58, `x = <tspan fill="${ORANGE}" font-weight="bold">−5</tspan>`, 16, ENCRE, 250, 'start')}
  ${ligne(94, 'Le signe compte : 3 − 8, c’est −5.', 11, GRIS)}

  <!-- 2. 3x = 12 -->
  ${ligne(130, `<tspan fill="${BLEU}" font-weight="bold">3</tspan><tspan font-weight="bold">x</tspan> = 12`, 18, ENCRE, 110)}
  ${defaire(102, 148, '÷ 3')}
  ${defaire(146, 148, '÷ 3')}
  ${ligne(124, 'x = 12 ÷ 3', 16, ENCRE, 250, 'start')}
  ${ligne(148, `x = <tspan fill="${ORANGE}" font-weight="bold">4</tspan>`, 16, ENCRE, 250, 'start')}

  <!-- 3. le geste -->
  ${ligne(192, `Je défais l’opération, <tspan font-weight="bold">des deux côtés</tspan> :`, 13)}
  ${ligne(212, '« + 8 » se défait avec « − 8 », « × 3 » se défait avec « ÷ 3 ».', 12)}`,
    228,
);

// ─── 1226 : 3x + 2 = 14 ────────────────────────────────────────────────────

const SVG_DEUX_ETAPES = svg(
    '3x plus 2 égale 14. Première étape : moins 2 des deux côtés, il reste 3x égale 12. Deuxième étape : divisé par 3 des deux côtés, x égale 12 divisé par 3, donc x égale 4. Le nombre seul d’abord, la division ensuite. Vérification : 3 fois 4 plus 2 égale 14.',
    `<!-- 1. l'équation -->
  ${ligne(40, `<tspan fill="${BLEU}" font-weight="bold">3</tspan><tspan font-weight="bold">x</tspan> <tspan fill="${ORANGE}" font-weight="bold">+ 2</tspan> = 14`, 18)}
  ${defaire(170, 58, '− 2')}
  ${defaire(236, 58, '− 2')}
  ${ligne(72, '1. le nombre seul d’abord', 11, GRIS, 262, 'start')}

  <!-- 2. après la première étape -->
  ${ligne(104, `<tspan fill="${BLEU}" font-weight="bold">3</tspan><tspan font-weight="bold">x</tspan> = 12`, 18)}
  ${defaire(184, 122, '÷ 3')}
  ${defaire(218, 122, '÷ 3')}
  ${ligne(136, '2. la division ensuite', 11, GRIS, 250, 'start')}

  <!-- 3. la solution -->
  ${ligne(164, 'x = 12 ÷ 3', 18, ENCRE, 166, 'start')}
  ${ligne(190, `x = <tspan fill="${ORANGE}" font-weight="bold">4</tspan>`, 18, ENCRE, 166, 'start')}

  <!-- 4. le geste -->
  ${ligne(222, 'D’abord je retire le nombre seul, ensuite je divise.', 13)}
  ${ligne(244, 'Je vérifie : 3 × 4 + 2 = 14.', 12, GRIS)}`,
    260,
);

const AIDE_UNE_ETAPE = { pages: [{ titre: 'Je défais l’opération', svg: SVG_UNE_ETAPE }] };
const AIDE_DEUX_ETAPES = { pages: [{ titre: 'Deux étapes', svg: SVG_DEUX_ETAPES }] };

const CP_1225 = {
    simple_guide_texte_trou_saisie: AIDE_UNE_ETAPE,
    simple_flash_texte_trou_saisie: AIDE_UNE_ETAPE,
    simple_solution_qcm_unique: AIDE_UNE_ETAPE,
};
/** 1226 : les clés etapes_* de gen_1225, servies par gen_1226. */
export const CP_1226 = {
    etapes_guide_texte_trou_saisie: AIDE_DEUX_ETAPES,
    etapes_flash_texte_trou_saisie: AIDE_DEUX_ETAPES,
    etapes_solution_qcm_unique: AIDE_DEUX_ETAPES,
};

export default CP_1225;
